import React from 'react';
import { Link } from 'react-router-dom';
import { clearExploreFlag } from './EarlyAccessGate';

const Footer = ({ isAuthenticated }) => {
  const currentYear = new Date().getFullYear();
  
  // Check if user is logged in
  const isLoggedIn = isAuthenticated || !!localStorage.getItem('token');
  
  // Handle returning to Early Access page
  const handleReturnToEarlyAccess = (e) => {
    e.preventDefault();
    clearExploreFlag();
    window.location.href = '/early-access';
  };

  return (
    <footer className="bg-gray-900 border-t border-gray-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-white font-bold mb-4">Trap Comix</h3>
            <p className="text-gray-400 text-sm mb-4">
              A platform for underrepresented comic artists, illustrators, and novelists. 
              Your stories, your IP, your revenue.
            </p>
            <div className="flex gap-3">
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path></svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path><circle cx="4" cy="4" r="2"></circle></svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"></path></svg>
              </a>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h3 className="text-white font-semibold mb-4">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/comics" className="text-gray-400 hover:text-orange-500 transition-colors">Browse Comics</Link></li>
              <li><Link to="/novels" className="text-gray-400 hover:text-orange-500 transition-colors">Browse Novels</Link></li>
              <li><Link to="/art-gallery" className="text-gray-400 hover:text-orange-500 transition-colors">Art Gallery</Link></li>
              <li><Link to="/music" className="text-gray-400 hover:text-orange-500 transition-colors">Music</Link></li>
              <li><Link to="/publish" className="text-gray-400 hover:text-orange-500 transition-colors">Start Publishing</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">Help Center</a></li>
              <li><a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">Creator Guide</a></li>
              <li><a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">Community Forums</a></li>
              <li><a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">API Documentation</a></li>
              <li><a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">Brand Assets</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="text-gray-400 hover:text-orange-500 transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-orange-500 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/dmca" className="text-gray-400 hover:text-orange-500 transition-colors">DMCA Policy</Link></li>
              <li><Link to="/content-guidelines" className="text-gray-400 hover:text-orange-500 transition-colors">Content Guidelines</Link></li>
              <li><a href="mailto:macmiles1623@gmail.com" className="text-gray-400 hover:text-orange-500 transition-colors">Contact Us</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Trap Comix. All rights reserved.
            </p>
            <div className="flex gap-4 text-sm items-center">
              {/* Early Access link for logged-out users */}
              {!isLoggedIn && (
                <>
                  <button
                    onClick={handleReturnToEarlyAccess}
                    className="text-orange-500 hover:text-orange-400 transition-colors font-medium"
                  >
                    Early Access
                  </button>
                  <span className="text-gray-600">•</span>
                </>
              )}
              <a href="mailto:macmiles1623@gmail.com" className="text-gray-400 hover:text-orange-500 transition-colors">
                Support
              </a>
              <span className="text-gray-600">•</span>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                Careers
              </a>
              <span className="text-gray-600">•</span>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">
                Blog
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
